import React, { useState, useEffect } from "react";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setToken } from "./AuthReducer";
import { BaseUrl } from "../shared/BaseUrl";
import { Link } from "react-router-dom";
import logo from "../image/logo.png";
import patternBg from "../image/landing/designer/bg-patterns.webp";
import { FiEye, FiEyeOff } from "react-icons/fi";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const authNavItems = [
    { label: "About Us", path: "/about-us" },
    { label: "Services", path: "/services" },
    { label: "How It Works", path: "/how-it-works" },
    { label: "Testimonials", path: "/testimonials" },
    { label: "Contact", path: "/contact-us" },
  ];

  useEffect(() => {
    const savedToken = localStorage.getItem("token");
    if (savedToken) {
      dispatch(setToken({ token: savedToken }));
    }
  }, [dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Show spinner
    try {
      const response = await axios.post(`${BaseUrl}/api/auth/login`, {
        username,
        password,
      });
      // If login is successful, handle the response here
      console.log("Login success:", response.data);
      // localStorage.setItem("token", response?.data?.token);
      localStorage.setItem("username", response?.data?.data?.username);
      localStorage.setItem("email", response?.data?.data?.email || "");
      dispatch(setToken({ token: response?.data?.token }));
      toast.success(response.data.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      if (response.data.data) {
        setLoading(false);
      }
      // Navigate to the desired page after successful login
      // navigate("/m");
      // localStorage.setItem("token", response?.data?.token);
      // window.location.href = `https://www.tq2.ai?token=${response?.data?.token}`;
      const userRole = response.data.data.role; // Adjust this based on your API response
      if (userRole === "admin") {
        localStorage.setItem("token", response?.data?.token);
        navigate("/admin");
      } else if (userRole === "user") {
        // localStorage.setItem("token", response?.data?.token);
      // navigate("/m");
        
        window.location.href = `https://www.tq2.ai?token=${response?.data?.token}&username=${response?.data?.data?.username}`;
      }
    } catch (error) {
      console.error("Login error:", error.message);
      const message =
        error.response?.data?.message ||
        error.message ||
        "Login failed. Please try again.";
      toast.error(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="auth-page"
      style={{ "--auth-pattern-image": `url(${patternBg})` }}
    >
      <header className="auth-nav">
        <button
          type="button"
          className="auth-logo-button"
          onClick={() => navigate("/landing")}
          aria-label="Go to landing page"
        >
          <img src={logo} alt="TattQR logo" />
        </button>
        <nav className="auth-nav-links">
          {authNavItems.map((item) => (
            <Link key={item.path} to={item.path}>
              {item.label}
            </Link>
          ))}
        </nav>
        <div className="auth-nav-actions">
          <button type="button" className="auth-btn auth-btn-outline active">
            Login
          </button>
          <button
            type="button"
            className="auth-btn auth-btn-gold"
            onClick={() => navigate("/signup")}
          >
            Design My Qr
          </button>
        </div>
      </header>

      <main className="auth-main">
        <section className="auth-card auth-card-login">
          <span className="auth-corner auth-corner-tl" />
          <span className="auth-corner auth-corner-tr" />
          <span className="auth-corner auth-corner-bl" />
          <span className="auth-corner auth-corner-br" />
          <div className="auth-card-inner">
            <h1 className="auth-title">Welcome Back</h1>
            <p className="auth-subtitle">
              Log in to manage your QR code and track performance.
            </p>

            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="auth-field">
                <input
                  type="text"
                  id="username"
                  name="username"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  autoComplete="username"
                  required
                />
              </div>

              <div className="auth-field auth-field-password">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  required
                />
                <button
                  type="button"
                  className="auth-eye-toggle"
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>

              <button type="submit" className="auth-submit-btn" disabled={loading}>
                {loading ? "Logging In..." : "Log In"}
              </button>
            </form>

            <p className="auth-switch-text">
              Don&apos;t have an account? <Link to="/signup">Sign Up</Link>
            </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Login;
